// Racing World — Size pill selector on product cards
// File: assets/rw-size-pills.js

(function() {

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' SGD';
  }

  function initSizePills() {
    document.querySelectorAll('.rw-size-pills:not([data-init])').forEach(function(pills) {
      pills.setAttribute('data-init', '1');

      var card = pills.closest('product-card');
      if (!card) return;

      var productId = card.getAttribute('data-product-id');
      if (!productId) return;

      pills.querySelectorAll('.rw-size-pill').forEach(function(pill) {
        pill.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var variantId = pill.getAttribute('data-variant-id');
          var price     = pill.getAttribute('data-price');
          var compareAt = pill.getAttribute('data-compare-price');
          var size      = pill.getAttribute('data-size');

          // ── Mark selected ──
          pills.querySelectorAll('.rw-size-pill').forEach(function(p) {
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');

          // ── Update ALL card links to variant URL ──
          var baseUrl = null;
          var link = card.querySelector('.product-card__link');
          if (link) {
            baseUrl = link.getAttribute('href').split('?')[0];
            link.setAttribute('href', baseUrl + '?variant=' + variantId);
          }

          var galleryLink = card.querySelector('[ref="cardGalleryLink"]');
          if (galleryLink && baseUrl) {
            galleryLink.setAttribute('href', baseUrl + '?variant=' + variantId);
          }

          var titleLink = card.querySelector('[ref="productTitleLink"]');
          if (titleLink && baseUrl) {
            titleLink.setAttribute('href', baseUrl + '?variant=' + variantId);
          }

          // ── Update variant input in quick add form ──
          var variantInput = card.querySelector('[ref="variantId"]');
          if (variantInput) variantInput.value = variantId;

          // ── Update price display ──
          if (price) {
            var salePriceEl    = card.querySelector('.price-item--sale');
            var regularPriceEl = card.querySelector('.price__regular .price');
            if (salePriceEl) {
              salePriceEl.textContent = formatMoney(parseInt(price));
            } else if (regularPriceEl) {
              regularPriceEl.textContent = formatMoney(parseInt(price));
            }
            var compareEl = card.querySelector('.compare-at-price');
            if (compareEl) {
              if (compareAt && parseInt(compareAt) > parseInt(price)) {
                compareEl.textContent = formatMoney(parseInt(compareAt));
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
          }

          // ── Navigate immediately to variant URL ──
          if (baseUrl && variantId) {
            window.location.href = baseUrl + '?variant=' + variantId;
          }
        });
      });
    });
  }

  /* ── PRODUCT PAGE: auto-select variant from URL ──
     Horizon already handles ?variant= in the URL natively —
     so just landing on the URL with ?variant=ID is enough.
     This is a fallback for themes that don't auto-select.
  ── */
  function autoSelectFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;

    // Horizon OS2 handles this natively via the URL.
    // Fallback: find the radio with this variant ID and click it
    var input = document.querySelector('input[value="' + variantId + '"]') ||
                document.querySelector('[data-variant-id="' + variantId + '"]');
    if (input) {
      input.click();
    }
  }

  // ── INIT ──
  document.addEventListener('DOMContentLoaded', function() {
    initSizePills();
    autoSelectFromUrl();
  });

  // Re-init for infinite scroll / dynamic cards
  var observer = new MutationObserver(function() { initSizePills(); });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(autoSelectFromUrl, 300);

})();